import { getEnv } from '../../config/env';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { logger } from '../../utils/logger';
import { getV2AuthHeaders } from '../../utils/authHeaders';

/**
 * Toggles the isActive state of a snapshot
 * @param accessToken - Bearer token for authentication
 * @param snapshotId - ID of the snapshot to toggle
 * @returns The updated snapshot object
 */
export async function toggleSnapshotActive(
  accessToken: string,
  snapshotId: string
): Promise<{ isActive: boolean }> {
  const env = getEnv();
  const baseUrl = env.VITE_EDCI_API_URL.replace(/\/$/, '');
  const url = `${baseUrl}/api/migrations/${snapshotId}/toggle-active`;

  logger.info('Toggling snapshot active state', { snapshotId });

  try {
    const response = await authenticatedFetch(url, {
      method: 'PATCH',
      headers: {
        ...getV2AuthHeaders(accessToken),
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      logger.error('Failed to toggle snapshot active state', {
        snapshotId,
        status: response.status,
        statusText: response.statusText
      });
      throw new Error(`Failed to toggle snapshot: ${response.statusText}`);
    }

    const data = await response.json();
    logger.info('Snapshot active state toggled successfully', {
      snapshotId,
      isActive: data.isActive
    });
    return data;
  } catch (error) {
    logger.error('Error toggling snapshot active state', { snapshotId, error });
    throw error;
  }
}

export default toggleSnapshotActive;
